import { DIID } from "@archipad-js/dependency-injection";
import { UserManager } from "oidc-client-ts";
import { OAuthClientService } from "./oauth-client.service";

export const OAuth_Client_Service_DIID = DIID<OAuthClientService>("OAuthClient.Service");

export const OAuth_Client_UserManager_DIID = DIID<UserManager>("OAuthClient.Service.UserManager");
